﻿import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Grid,
  IconButton,
  Modal,
  Snackbar,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { BIGrey, BILightGrey } from "../../assets/helpers";
import {
  FETCH_SAR_NOTES_TYPES,
  SAVE_CLIENT_NOTES,
  SAVE_CLIENT_NOTES_PICTURES
} from "../../constant/Apipath";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { English } from "../../constant/EnglishFallback";
import PictureViewer from "../../common/PictureViewer";

export default function ClientNotesAddModal({ open, onClose, SARid, reloadData }) {
  const imgRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [deleteImageList, setDeleteImageList] = useState([]);
  const [uploadedImageList, setUploadedImageList] = useState([]);
  const [clientEmployeData, setClientEmployeData] = useState([]);
  const [description, setDescription] = useState("");
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [searchTerm, setSearchTerm] = useState("");
  const userId = loginData?.userInformation?.UserId;
  const [empData, setEmpData] = useState({
    id: 0,
    label: ""
  });
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  //for multi language
  const LANGUAGE = ClientEnglishFallback.ClientNotesAddModal(
    multiLanguageData?.ClientNotesAddModal || {}
  );
  const { TEXT_TYPE, TEXT_SELECT_TYPE, TEXT_DESCRIPTION, TEXT_TYPE_SOMETHING, TEXT_SAVE } =
    LANGUAGE;

  const { TEXT_NO_OPTIONS = English?.AddExperience?.TEXT_NO_OPTIONS } =
    multiLanguageData?.AddExperience || {};

  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;

  const handleAddImage = () => {
    imgRef.current.click();
  };

  useEffect(() => {
    if (open) getSARNotesTypes();
  }, [open]);

  const getSARNotesTypes = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientId: selectedClientData?.ClientId
          }
        ]
      };

      const res = await Postrequestcall(FETCH_SAR_NOTES_TYPES, obj, loginData?.accessToken);
      if (res.status === 200) {
        const datas = res?.data?.data;
        let temp = [];
        datas?.map((data) => {
          if (data?.id != selectedClientData?.ClientEmployeeId) {
            temp.push({
              id: data.id,
              label: data.noteTypeName,
              shortDescription: data.shortDescription
            });
          }
        });
        setClientEmployeData(temp);
      }
    } catch (error) {
      console.log('getSARNotesTypes-> Error Getting SAR Notes Types: ', error);
    }
  };

  const handleCreateReport = async () => {
    // if (uploadedImageList.length === 0) {
    //   setSnackbarMsg("Please select at least one image before saving.");
    //   setSnackbarOpen(true);
    //   return;
    // }
    setLoading(true);
    try {
      const payload = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        UserId: userId,
        SaveList: [
          {
            Id: 0,
            SARId: SARid,
            NoteTypeId: empData?.id,
            Description: description,
            ModifiedBy: userId
          }
        ]
      };

      const res = await Postrequestcall(SAVE_CLIENT_NOTES, payload, TOKEN);

      if (res.status === 201) {
        if (uploadedImageList?.length > 0) {
          const uploadPromises = Array.from(uploadedImageList)?.map(async (picture) => {
            const formData = new FormData();
            formData.append("Id", picture.id ?? 0);
            formData.append("SARNoteId", res?.data?.data[0]?.objData?.id);
            formData.append("ModifiedBy", userId);
            formData.append("FileName", picture);
            await Fileuploadrequestcall(SAVE_CLIENT_NOTES_PICTURES, formData, TOKEN);
          });
          try {
            await Promise.all(uploadPromises);
          } catch (error) {
            console.error("handleCreateReport-> Error Saving Client Notes Pictures: ", error);
          }
        }
      }
    } catch (err) {
      console.log("handleCreateReport-> Error Saving Client Notes : ", err);
    } finally {
      setLoading(false);
      resetData();
      reloadData();
      onClose();
    }
  };

  const handleImageChange = (event) => {
    let temp = [...uploadedImageList];
    let files = event.target.files;
    let nonImageFound = false;
    for (let i = 0; i < files?.length; i++) {
      if (!files[i].type || !files[i].type.startsWith("image/")) {
        nonImageFound = true;
        break;
      }
    }
    if (nonImageFound) {
      setSnackbarOpen(true);
      event.target.value = "";
      return;
    }
    for (let i = 0; i < files?.length; i++) {
      temp.push(files[i]);
    }
    setUploadedImageList(temp);
    event.target.value = "";
  };

  const handleInputChange = (value, field) => {
    setEmpData({ ...value });
  };

  const handleRemoveImage = useCallback(
    (picture, index) => {
      const deleteList = [...deleteImageList];
      if (picture.id) {
        deleteList.push({ id: picture?.id });
      }
      setDeleteImageList(deleteList);
      let temp = [...uploadedImageList];
      temp.splice(index, 1);
      setUploadedImageList(temp);
    },
    [uploadedImageList, deleteImageList]
  );

  const resetData = () => {
    setUploadedImageList([]);
    setDescription("");
    // reloadData();
  };

  // Helper to get image URLs for PictureViewer
  const getImageUrls = () => {
    return uploadedImageList.map((picture) => {
      try {
        return { src: URL.createObjectURL(picture), alt: "" };
      } catch (error) {
        return { src: picture?.fileUrl || picture, alt: "" };
      }
    });
  };

  return (
    <>
      {snackbarOpen && (
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          message={snackbarMsg || "Only image files are allowed."}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        />
      )}
      <Modal
        open={open}
        onClose={() => {
          resetData();
          // onClose();
        }}>
        <div className="client-modal-responsive">
          <div className="action-button-container">
            <IconButton
              onClick={() => {
                resetData();
                onClose();
              }}
              sx={{
                color:
                  selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                    ? selectedClientData?.AccentColor
                    : BILightGrey
              }}>
              <CloseIcon />
            </IconButton>
          </div>
          <Stack
            sx={{ padding: {
              xs: 0,
              sm: 0,
              md: 0.5,
              lg: 0.5,
              xl: 1
             }}}>
            <Grid container sx={{ display: "flex", flexDirection: "column" }}>
              <Grid>
                <Typography variant="subtitle1">{TEXT_TYPE}</Typography>
                <Autocomplete
                  disablePortal
                  options={clientEmployeData}
                  noOptionsText={TEXT_NO_OPTIONS}
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  sx={{
                    "& fieldset": { border: "none" }
                  }}
                  size="small"
                  variant="outlined"
                  required
                  fullWidth
                  value={clientEmployeData.find((option) => option.id === empData.id) || null}
                  inputValue={searchTerm}
                  onInputChange={(_, value, reason) => {
                    if (reason === "input") {
                      let inputValue = value.replace(/^[^A-Za-z0-9]+/, "");
                      setSearchTerm(inputValue);
                    }
                  }}
                  onChange={(_, selectedEmployee) => {
                    if (selectedEmployee) {
                      handleInputChange(selectedEmployee, "employee");
                      setSearchTerm(selectedEmployee.label);
                    } else {
                      setEmpData({ id: 0, label: "" });
                      setSearchTerm("");
                    }
                  }}
                  renderInput={(params) => <TextField placeholder={TEXT_SELECT_TYPE} {...params} />}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
              </Grid>
              <Grid size={12}>
                <Typography
                  sx={{
                    mt: 1,
                    mb: 1,
                    color: BIGrey
                  }}
                  variant="subtitle1">
                  {empData?.shortDescription}
                </Typography>
              </Grid>
              <Grid size={12}>
                <Typography variant="subtitle1">{TEXT_DESCRIPTION}</Typography>
                <TextField
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  rows={4}
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  size="small"
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  placeholder={TEXT_TYPE_SOMETHING}
                  value={description}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    setDescription(inputValue);
                  }}
                />
              </Grid>
              <Grid sx={{ gap: 2,  marginTop: 2,  display: "flex"  }} size={12}  >
                <div
                  onClick={handleAddImage}
                  style={{
                    cursor: "pointer",
                    height: "100px",
                    minWidth: "100px",
                    border: "2px solid #e4e4e4",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                  <AddIcon />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    maxWidth: "100%",
                    scrollbarWidth: "none",
                    overflow: "scroll"
                  }}>
                  {uploadedImageList.length > 0 && (
                    <>
                      <ImageMemoComponent
                        selectedClientData={selectedClientData}
                        uploadedImageList={uploadedImageList}
                        handleRemoveImage={handleRemoveImage}
                        onImageClick={(idx) => {
                          setViewerIndex(idx);
                          setViewerOpen(true);
                        }}
                      />
                      <PictureViewer
                        isOpen={viewerOpen}
                        onClose={() => setViewerOpen(false)}
                        pictures={getImageUrls()}
                        viewerIndex={viewerIndex}
                      />
                    </>
                  )}
                </div>
              </Grid>
            </Grid>

            <Grid>
              <LoadingButton
                onClick={handleCreateReport}
                fullWidth
                disabled={!description}
                style={{
                  marginTop: "10px",
                  background: !description ? BILightGrey : CLIENT_ACCENT_COLOR,
                  color: "white",
                  borderRadius: "10px"
                }}
                loadingPosition="start"
                loading={loading}
                variant="contained"
                startIcon={<></>}>
                {TEXT_SAVE}
              </LoadingButton>
            </Grid>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              ref={imgRef}
              style={{ display: "none" }}
              multiple
            />
          </Stack>
        </div>
      </Modal>
    </>
  );
}

const ImageList = ({ uploadedImageList, handleRemoveImage, selectedClientData, onImageClick }) => {
  const ImgUrl = (file) => {
    try {
      let url = URL.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };
  return uploadedImageList?.map((picture, index) => (
    <div style={{ position: "relative", height: "100px" }} key={index}>
      <img
        src={picture?.fileUrl || ImgUrl(picture)}
        alt={"NO data"}
        style={{
          width: "100px",
          height: "100px",
          borderRadius: "10px",
          cursor: onImageClick ? "pointer" : undefined
        }}
        loading="lazy"
        onClick={onImageClick ? () => onImageClick(index) : undefined}
      />
      <IconButton
        onClick={() => handleRemoveImage(picture, index)}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          padding: "5px",
          color:
            selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
              ? selectedClientData?.AccentColor
              : BILightGrey,
          backgroundColor: "rgba(0,0,0,0.3)"
        }}>
        <CloseIcon style={{ fontSize: "16px" }} />
      </IconButton>
    </div>
  ));
};

const ImageMemoComponent = memo(ImageList);

